import React, { useRef, useCallback, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Editor } from '@tiptap/react';

import { commentsModel } from '../model';
import { CreateCommentPopup } from './CreateCommentPopup';
import { CommentsFlow } from '../model/types';
import { CommentsPreviewList } from './CommentsPreviewList';
import { useOnClickOutside } from '../../../shared/hooks/useClickOutside';

export const CommentsPreviewSideBarContainer = memo(
  ({ editor }: { editor: Editor }) => {
    const dispatch = useDispatch();
    const commentsFlow = useSelector(
      commentsModel.selectors.selectCommentsFlow
    );
    const containerRef = useRef(null);

    const handleOutsideClick = useCallback(
      (event: MouseEvent | TouchEvent) => {
        const target = event.target as HTMLElement;
        const threadElement = target.closest(
          '[data-inline-thread-id], [data-block-thread-id]'
        );

        if (threadElement) {
          const id =
            threadElement.getAttribute('data-block-thread-id') ||
            threadElement.getAttribute('data-inline-thread-id');

          if (id) {
            editor.commands.selectThread({ id });
            return;
          }
        }

        if (commentsFlow === CommentsFlow.Create) {
          dispatch(commentsModel.actions.endCommentingFlow());
        } else {
          editor.commands.selectThread({ id: null });
          dispatch(commentsModel.actions.setCommentsFlow(null));
        }
      },
      [dispatch, editor, commentsFlow]
    );

    useOnClickOutside(containerRef, handleOutsideClick);

    if (!commentsFlow) return null;

    return (
      <div className="w-90 m-w-90">
        <div className="flex flex-col justify-center h-full w-full">
          <div ref={containerRef} className="max-h-full overflow-auto">
            {commentsFlow === CommentsFlow.Create && <CreateCommentPopup />}
            {commentsFlow === CommentsFlow.Preview && <CommentsPreviewList />}
          </div>
        </div>
      </div>
    );
  }
);
